<template>
    <div class="recent-color-palette d-flex">
        <button class="color-palette" v-for="(color, index) in recentColors" v-bind:style="{ backgroundColor: color }" v-on:click.prevent="chooseColor(color)" v-bind:key="index"></button>
        <div class="color-palette-spacer" v-for="n in placeholderCount" v-bind:key="'placeholder' + n"></div>
    </div>
</template>

<script>
    export default {
        props: {
            recentColors: {
                type: Array,
                default: function () {
                    return [];
                }
            },
        },
        computed: {
            placeholderCount: function() {
                return 12 - this.recentColors.length;
            },
        },
        methods: {
            chooseColor: function(color) {
                this.$emit('choosecolor', color);
            }
        }
    }
</script>
